import { render, staticRenderFns } from "./DetailDeal.vue?vue&type=template&id=45415f90&"
import script from "./DetailDeal.vue?vue&type=script&lang=js&"
export * from "./DetailDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports